// store/modalSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ModalTypes = "logout" | "edit";

type ModalState = {
  activeModal: ModalTypes | null;
};

const initialState: ModalState = {
  activeModal: null,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal(state, action: PayloadAction<ModalTypes>) {
      state.activeModal = action.payload;
    },
    closeModal(state) {
      state.activeModal = null;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
